.marqueeContainer {
  position: relative;
  overflow: hidden;
  width: 585px;
  height: 80px;
  gap: 80px;
  margin-left: auto;
  margin-right: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.marqueeContainer::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 50%;
  height: 1px;
  background: linear-gradient(
    90deg,
    #171717 15.37%,
    #858585 50.98%,
    #171717 80.66%
  );
  opacity: 0.8;
  z-index: 10;
  transform: translateX(50%);
}

.marqueeContent {
  display: flex;
  gap: 40px;
  white-space: nowrap;
  animation: scrollLeft 30s linear infinite;
  margin-top: 16px;
}

.marqueeItem {
  flex: 0 0 auto;
  text-align: center;
  color: var(--text-color-2);
  width: 140px;
  height: 52;
  gap: 8px;
}

.title {
  width: 117;
  height: 17;
  font-size: 14px;
  margin: 0;
  text-align: start;
}

.value {
  font-family: "Ndot47";
  font-weight: 400;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 4%;
  color: var(--green);
  text-align: start;
  margin: 8px 0;
  display: flex;
  gap: 2px;
}

@keyframes scrollLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

.marqueeOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: var(--gradient-grey);
}

.digitWrapper {
  display: inline-block;
  overflow: hidden;
  height: 24px;
  width: 12px;
  position: relative;
}

.digit {
  display: inline-block;
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  text-align: center;
}

.unit {
  margin-left: 4px;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
}

@media (max-width: 720px) {
  .marqueeContainer {
    width: unset;
  }
  .marqueeItem {
    width: 110px;
  }
  .title {
    font-weight: 300;
    font-size: 12px;
    line-height: 100%;
    vertical-align: middle;
  }
  .value {
    margin: 4px 0;
    font-weight: 400;
    font-size: 16px;
  }
  .digitWrapper {
    width: 10px;
    height: 16px;
  }
  .unit {
    font-size: 12px;
  }
}

@media (max-width: 400px) {
  .marqueeContent {
    gap: 20px;
  }
  .digitWrapper {
    width: 8px;
    height: 14px;
}
  .value {
    margin: 4px 0;
    font-size: 14px;
    font-weight: 400;
  }
}
